import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { NavbarComponent } from '../navbar/navbar.component';
import { RouterOutlet } from '@angular/router';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-base',
  standalone: true,
  imports: [NavbarComponent, RouterOutlet, SidebarComponent, CommonModule],
  templateUrl: './base.component.html',
  styleUrl: './base.component.scss'
})
export class BaseComponent implements OnInit {
  isLoading = true; // Default to true while loading

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    // Simulate loading with a timeout
    setTimeout(() => {
      this.isLoading = false;

      // Trigger change detection manually
      this.cdr.detectChanges();
    }, 1000); // Adjust the timeout as needed
  }
}
